export function conditionalMap(condition, mapFunction, data) {
    return condition ? mapFunction(data) : data;
}
export function conditionalValue(condition, value, defaultValue) {
    return condition ? value : defaultValue;
}
//# sourceMappingURL=conditionalMap.js.map